angular
  .module('common.directives')
  .directive('multipleBroadcastVideos', function () {
    return {
      scope: {
        organizationId: '='
      },
      templateUrl:
        './templates/multiple.broadcast.videos.depracated.views.html?t=' +
        webpackHash,
      controller: 'multipleBroadcastVideosCtrlDeprecated',
      link: function ($scope, $element) {}
    }
  })
